
import FaqSection from '../components/home/FaqSection.vue';

export default {
  layout(context) {
    return context.$auth.loggedIn ? 'parents' : 'home';
  },
  components: {
    FaqSection
  }
};
